export default __webpack_public_path__ + "static/1-85b3cff4fd3bdebf25d9adf07d91106d.jpg";